module.exports = __webpack_public_path__ + "media/images/emblems/Ruettenen-blason-6a5b3a2f633fce91a578723153151fcd.png";